import { useState } from 'react';
import { FormControl, Stack, FormLabel, Box } from '@chakra-ui/react';
import { Field } from 'formik';
import { useCompanyForm } from '../../hooks/useCompanyForm';
import NameField from '@/components/forms/new/formikFormFields/NameField';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import { getBillingFieldPaths, getBillingSettings } from '../../constants';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
} from 'components/forms/new/formStyles';

const TrackingName2 = ({ darkMode, errors, touched }) => {
    const [isHovered, setIsHovered] = useState(false);
    const { formData, updateFormData, mode } = useCompanyForm();
    const billingFieldPaths = getBillingFieldPaths(mode);
    const billingSettings = getBillingSettings(formData, mode);
    const handleChange = (e) => {
        updateFormData(billingFieldPaths.TRACKING_NAME_2, e.target.value);
    };
    const hasError = !!errors?.trackingName2 && touched?.trackingName2;
    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={hasError}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack direction="row" spacing={stackSpacing} sx={stackStyling()}>
                <FormLabel sx={formLabelStyling(darkMode)}>
                    Tracking Name 2
                </FormLabel>
                <Box flex={1} maxWidth="400px">
                    <Field
                        component={NameField}
                        id="trackingName2"
                        name="trackingName2"
                        value={billingSettings?.trackingName2 || ''}
                        onChange={handleChange}
                        placeholder="Tracking Name 2"
                        width="100%"
                        darkMode={darkMode}
                        isInvalid={hasError}
                    />
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="Enter tracking name 2 for this company"
                        ariaLabel="trackingname2-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};
export default TrackingName2;
